import { Copy } from '../copy/Copy';

export const ADD_ACTIVITY_INIT_VALUES = {
  date: '',
  distance: '',
  activity: '',
  mood: '',
};

export const ACTIVITY_TABLE_COLUMNS = [
  { id: 'formattedDate', label: Copy.generate('Tables.labels.date') },
  { id: 'distance', label: Copy.generate('Tables.labels.distance') },
  {
    id: 'activity',
    label: Copy.generate('Tables.labels.activity'),
  },
];

export const ADD_ACTIVITY_SELECT_OPTIONS = [
  {
    label: Copy.generate('Global.walking'),
    value: 'WALKING',
  },
  {
    label: Copy.generate('Global.running'),
    value: 'RUNNING',
  },
  {
    label: Copy.generate('Global.cycling'),
    value: 'CYCLING',
  },
  {
    label: Copy.generate('Global.swimming'),
    value: 'SWIMMING',
  },
  {
    label: Copy.generate('Global.other'),
    value: 'OTHER',
  },
];
